/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React
//, 
//{useState} 
from "react";
import { Link } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
//import { connect } from "react-redux";
import { toAbsoluteUrl } from "../../../_metronic";
import HeaderDropdownToggle from "../content/CustomDropdowns/HeaderDropdownToggle";
import { getUserByToken } from "../../crud/auth.crud";

export default class UserProfile extends React.Component {
  state = {
    users:[],
    user:{}
  }

/*
constructor(props)
{
  super(props);

    
}
*/
  
  componentDidMount()
  {
    
    getUserByToken().then(response => response.data)
    .then((data) => {
      this.setState({users: data});
      this.state.users.map((user) => (
          this.setState({ user: user })
        ));
      
      
     })
    
      
      
  }
 

  render() {
    const { showHi, showAvatar, showBadge } = this.props;
    const user = this.state.user;
    return (

      

      <Dropdown className="kt-header__topbar-item kt-header__topbar-item--user" drop="down" alignRight>
        <Dropdown.Toggle
          as={HeaderDropdownToggle}
          id="dropdown-toggle-user-profile"
        >
          <div className="kt-header__topbar-user">
            {showHi && (
              <span className="kt-header__topbar-welcome">
                Hi,
              </span>
            )}

            {showHi && (
              <span className="kt-header__topbar-username kt-hidden-mobile">
                {user.firstName} 
              </span>
            )}

            {showAvatar && <img alt="Pic" src={user.pic} />}

            {showBadge && (
              <span className="kt-badge kt-badge--username kt-badge--unified-success kt-badge--lg kt-badge--rounded kt-badge--bold">
                {/* TODO: Should get from currentUser */}
                 {user.firstName}
              </span>
            )}
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu className="dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl">
          {/** ClassName should be 'dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl' */}
          <div
            className="kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x"
            style={{
              backgroundImage: `url(${toAbsoluteUrl("/media/misc/bg-1.jpg")})`
            }}
          >
            <div className="kt-user-card__avatar">
              {<img alt="Pic" className="kt-hidden" src={user.pic} />}
             {/*} <span className="kt-badge kt-badge--lg kt-badge--rounded kt-badge--bold kt-font-success">
                {(this.state.user.fullname).substring(0,1).toUpperCase()}
              </span>*/}
            </div>
            <div className="kt-user-card__name">{user.firstName} {user.lastName}</div>
            <div className="kt-user-card__badge">
              <span className="btn btn-success btn-sm btn-bold btn-font-md">
                {user.role}
              </span>
            </div>
          </div>
          <div className="kt-notification">
            <a className="kt-notification__item">
              <div className="kt-notification__item-icon">
                <i className="flaticon2-calendar-3 kt-font-success" />
              </div>
              <div className="kt-notification__item-details">
                <div className="kt-notification__item-title kt-font-bold">
                <Link
                    to="/myprofile"
                    className="kt-link kt-login__link-forgot">
                  My Profile
                </Link>

                  
                </div>
                <div className="kt-notification__item-time">
                  Account settings and more
                </div>
              </div>
            </a>
           {/* <a className="kt-notification__item">
              <div className="kt-notification__item-icon">
                <i className="flaticon2-mail kt-font-warning" />
              </div>
              <div className="kt-notification__item-details">
                <div className="kt-notification__item-title kt-font-bold">
                  My Messages
                </div>
                <div className="kt-notification__item-time">
                  Inbox and tasks
                </div>
              </div>
            </a>
            <a className="kt-notification__item">
              <div className="kt-notification__item-icon">
                <i className="flaticon2-rocket-1 kt-font-danger" />
              </div>
              <div className="kt-notification__item-details">
                <div className="kt-notification__item-title kt-font-bold">
                  My Activities
                </div>
                <div className="kt-notification__item-time">
                  Logs and notifications
                </div>
              </div>
            </a>*/}
            {this.state.user.role !== 'Portal Administrator' && this.state.user.role !== 'Practice Admin' &&
            <a className="kt-notification__item">
              <div className="kt-notification__item-icon">
                <i className="flaticon2-hourglass kt-font-brand" />
              </div>
              <div className="kt-notification__item-details">
                <div className="kt-notification__item-title kt-font-bold">
                  <Link
                    to="/schedule">
                  My To Do
                  </Link>
                  
                </div>
                <div className="kt-notification__item-time">
                  latest tasks and schedules
                
                  
                </div>
              </div>
            </a>
           }
            <div className="kt-notification__custom">
              <Link
                to="/logout"
                className="btn btn-label-brand btn-sm btn-bold"
              >
                Sign Out
              </Link>
            </div>
          </div>
        </Dropdown.Menu>
      </Dropdown>
      
    );
  }
}

